// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

if (process.env.NEXT_PUBLIC_ENV === 'production') {
  Sentry.init({
    dsn: SENTRY_DSN,
    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 1.0,
    // ...
    // Note: if you want to override the automatic release value, do not set a
    // `release` value here - use the environment variable `SENTRY_RELEASE`, so
    // that it will also get attached to your source maps
    ignoreErrors: [
      // 'Failed to fetch',
      // 'NetworkError',
      'Invalid token.',
      // 'Load failed',
      // 'multipart/form-data',
      // 'ResizeObserver',
      'ResizeObserver loop limit exceeded',
      'No record found',
      // 'Failed to fetch',
      'cancelled',
      // 'Access-Control-Allow-Origin.',
      'aborted.'
      // 'Invalid URL',
      // 'Bad Request'
    ]
  });
}
